module.exports = __webpack_public_path__ + "static/img/z2.866c4f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/z2.jpg
// module id = uW9x
// module chunks = 1